<template>
  <div>
    <PageEditorModal id="edit-page-editor-modal"
      v-show="true"
      v-bind:page="page"
      v-on:page-added="onPageAdded"
      v-bind:is-shown="true"
      v-on:cancel="cancelPageEdit">
    </PageEditorModal>

    <MathEditorModal id="math-editor-modal" v-on:add="addMath"></MathEditorModal>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { cloneDeep } from 'lodash';
  import PageEditorModal from '../../my-cards/components/PageEditorModal';
  import MathEditorModal from '../../my-cards/components/MathEditorModal';

  export default {
    name: 'edit-page',

    components: {
      PageEditorModal,
      MathEditorModal,
    },

    data() {
      return {
        busy: false,

        hasError: false,

        acceptableFileTypes: [
          'image/jpg',
          'image/jpeg',
          'image/png',
        ],

        fileSizeLimit: 10 * 1024 * 1024,

        page: {},
      };
    },

    computed: {
      ...mapGetters(['page', 'currentUserId']),
    },

    created() {
      return this.fetchAdminInfo(this.currentUserId)
        .then((adminData) => {
          if (!adminData) return this.$router.replace('/');

          return this.fetchPage(this.$route.params.page_id);
        })
        .then((page) => {
          this.page = page;
        })
        .catch(() => {
          this.$router.replace('/');
        });
    },

    methods: {
      ...mapActions(['fetchPage', 'updatePage', 'uploadPageImage', 'uploadPageAudio', 'fetchAdminInfo']),

      cancelPageEdit() {
        this.$router.go(-1);
      },

      onPageAdded(newQuizPage) {
        const pageId = this.$route.params.page_id;
        const newPageClone = cloneDeep(newQuizPage);

        const uploadImgPromises = newPageClone.images
          .filter(image => (typeof image.image_file !== 'string'))
          .map(image => (
          this.uploadPageImage({ pageId, imageFile: image.image_file })
          .then((newImage) => {
            if (newPageClone.content.indexOf(`data-image-id="${image.key}"`) !== -1) {
              newPageClone.content = newPageClone.content
                .replace(`data-image-id="${image.key}"`, `data-image-id="${newImage.id}"`)
                .replace(image.image_url, newImage.image_url);
            }

            if (newPageClone.description.indexOf(`data-image-id="${image.key}"`) !== -1) {
              newPageClone.description = newPageClone.description
                .replace(`data-image-id="${image.key}"`, `data-image-id="${newImage.id}"`)
                .replace(image.image_url, newImage.image_url);
            }
          })
        ));

        const uploadAudioPromises = newPageClone.audios.map(audio => (
          this.uploadPageAudio({ pageId, audioFile: audio.audio_file })
        ));

        return Promise.all([...uploadImgPromises, ...uploadAudioPromises])
          .then(() => (
            this.updatePage({ pageId, updateInfo: newPageClone })
          ))
          .catch(() => alert('문항 업데이트에 실패하였습니다.'))
          .finally(() => window.location.reload());
      },

      addMath(latex) {
        if (latex.length > 0) {
          const replacedLatex = latex.replace(/overarc/g, 'overparen');
          const mathInlineId = Math.floor(Math.random() * 1000);
          const content = `&nbsp;<span id="math-inline-${mathInlineId}" contenteditable="false">\\(${replacedLatex}\\)</span>&nbsp;`;
          let activeEditor;

          if (this.activeEditorId) {
            activeEditor = tinymce.get(this.activeEditorId);

            if (this.activeEditorLocation) {
              activeEditor.selection.setRng(this.activeEditorLocation);
            }
          } else {
            activeEditor = tinymce.activeEditor;
          }

          activeEditor.insertContent(content);

          setTimeout(() => {
            /* eslint-disable new-cap */
            MathJax.Hub.Queue(['Typeset', MathJax.Hub, `math-inline-${mathInlineId}`]);
            /* eslint-enable */
            activeEditor.insertContent('');
          }, 200);
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/app/edit-page/views/EditPage.vue